module.exports = __webpack_public_path__ + "626256ed.svg";